import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import CameraIcon2 from '@mui/icons-material/Camera';
import CamaraIconPNG from "../Image/Camera.jpeg"
import LoadingButtonsTransition from "./ButtonForReceipt";


const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('sm')]: {
        width: '100% !important', // Overrides inline-style
        height: 100,
    },
    '&:hover, &.Mui-focusVisible': {
        zIndex: 1,
        '& .MuiImageBackdrop-root': {
            opacity: 0.15,
        },
        '& .MuiImageMarked-root': {
            opacity: 0,
        },
        '& .MuiTypography-root': {
            border: '4px solid currentColor',
        },
    },
}));

const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
});

const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
}));

const ImageMarked = styled('span')(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
}));

export default function CameraIcon(props) {
    console.log(props)
    const IconHeight = window.innerHeight-130;
    const IconWidth = window.innerWidth;
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', minWidth: IconWidth, minHeight: IconHeight }}>
                <ImageButton
                    focusRipple
                    key={props.image.title}
                    sx={{minWidth:IconWidth, minHeight:IconHeight}}
                    onClick={props.controller}
                >
                    <ImageSrc style={{ backgroundImage: `url(${props.image.url})`, minWidth:IconWidth, minHeight:IconHeight}}/>
                    <ImageBackdrop className="MuiImageBackdrop-root" />
                    <Image sx={{minWidth:IconWidth, minHeight:IconHeight}}>
                        <Typography
                            component="span"
                            variant="subtitle1"
                            color="inherit"
                            sx={{
                                position: 'relative',
                                p: 4,
                                pt: 2,
                                pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                            }}
                        >
                            Scan Your Receipt
                            <CameraIcon2 style={{fontSize: "xxx-large", position:"absolute",left:30,bottom:-35, textShadow:"10px 10px red"}} fontSize={"large"}/>
                        </Typography>

                    </Image>
                </ImageButton>
        </Box>
    );
}